export default __webpack_public_path__ + "static/media/HYDRA.5ab20beb.jpg";